import React, { useState } from 'react'
import Button from '@vtex/styleguide/lib/Button'
import TopMessage from '@/checkout-instore-legacy/components/Commons/TopMessage'
import { FormattedMessage } from 'react-intl'
import fecha from 'fecha'
import get from 'lodash/get'
import { isRecent } from '@/checkout-instore-legacy/cache/CacheUtils'
import * as PullToRefresh from '@/checkout-instore-legacy/utils/PullToRefresh'

const ProductPageTopMessage = ({
  sku,
  showMessage,
  updatingProduct,
  errorWithCacheDisabled,
  handleProductRefresh,
}: {
  sku: Item | undefined
  showMessage: boolean
  updatingProduct: boolean
  errorWithCacheDisabled: any
  handleProductRefresh: () => void
}) => {
  const [showTopMessage, setShowTopMessage] = useState(showMessage)

  let refreshButton
  if (!PullToRefresh.isAvailable()) {
    refreshButton = (
      <Button
        id="refresh-product"
        onClick={handleProductRefresh}
        className="btn btn-default"
      >
        <FormattedMessage id="productPageUpdate" />
      </Button>
    )
  }

  let errorWithCacheDisabledMessage
  if (errorWithCacheDisabled) {
    errorWithCacheDisabledMessage = (
      <p>
        <FormattedMessage id="productErrorUpdatingTheProduct" />
      </p>
    )
  }

  const cacheActions = updatingProduct ? null : (
    <span>
      {errorWithCacheDisabledMessage}
      {refreshButton}
    </span>
  )

  const handleCloseTopMessage = () => {
    setShowTopMessage(false)
  }

  return (
    <div className="flex-none">
      {sku && get(sku, 'cachedSince') && !isRecent(sku) ? (
        <TopMessage type="warning">
          <FormattedMessage id="productPageCacheWarning" />
          {fecha.format(new Date(get(sku, 'cachedSince')), 'DD/MM [às] hh:mm')}
          <div>{cacheActions}</div>
        </TopMessage>
      ) : null}

      <TopMessage
        type="warning"
        message="O preço deste produto foi alterado."
        onClose={handleCloseTopMessage}
        isVisible={showTopMessage}
      />
    </div>
  )
}

export default ProductPageTopMessage
